import styled from 'styled-components';

const PageWithTableContainer = styled.div`
  width: 100%;
  &.withPadding {
    padding: 15px;
    .ant-pagination {
      margin-right: 0;
    }
  }
  .ant-pagination {
    margin-right: 10px;
  }
`;

export default PageWithTableContainer;
